// @ts-check

import { useMemo } from "react";
import useSWR from "swr";
import { SWR_CONFIG_FOR_STATIC_DATA } from "../constants/swr/swrConfigForStaticData";
import { useApiFetcher } from "./useApiFetcher";

/**
 * @template T
 * @template [M=any]
 * @typedef {object} UseApi
 * @prop {import("swr").SWRResponse<import("./useApiFetcher").ApiFetcherReturn<T, M>, any, any>} swrResponse
 */

/**
 * @template T
 * @template [M=any]
 * @param {string | string[] | null} info
 * @param {object} [options]
 * @param {Partial<import("swr/_internal").PublicConfiguration<import("./useApiFetcher").ApiFetcherReturn<T, M>>>} [options.swrConfig]
 * @returns {UseApi<T, M>}
 */
export function useApi(info, options = {}) {
  const { apiFetcher } = useApiFetcher();

  /** @type {import("swr").SWRResponse<import("./useApiFetcher").ApiFetcherReturn<T>>} */
  // @ts-ignore
  const swrResponse = useSWR(info, apiFetcher, {
    ...SWR_CONFIG_FOR_STATIC_DATA,
    ...options.swrConfig,
  });

  const value = useMemo(() => {
    return { swrResponse: swrResponse };
  }, [swrResponse]);

  return value;
}
